import { EventType } from "@/apiTypes/event";
import { cn } from "@/lib/utils";
import { getEventTypeBadgeColor } from "@/utils/eventDisplayUtils";
import { ClassValue } from "clsx";
import { FC } from "react";
import { Pill, PillSize, PillVariant } from "../ui/pill";

interface EventTypeBadgeProps {
  /**
   * The event type enum value
   */
  eventType: EventType;
  /**
   * (optional) CSS classnames to override the default styles
   */
  className?: ClassValue;
  size?: PillSize;
  variant?: PillVariant;
}

/**
 * Displays a color coordinated background event type badge.
 * For example - Race (orange), Ride (Blue), Route (Green)
 */
export const EventTypeBadge: FC<EventTypeBadgeProps> = ({
  eventType,
  size = "md",
  className,
  variant,
}) => {
  const badgeColor = getEventTypeBadgeColor(eventType, false);

  return (
    <Pill
      size={size}
      color={badgeColor}
      variant={variant}
      className={cn(className)}
    >
      {eventType}
    </Pill>
  );
};
